import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import Pagination from "components/ui/pagination/Pagination";

export default function ReturnedDataTable({data}) {
    const { t } = useTranslation();

    /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const returnedData= calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
            <Tr>
                <Th>{t("pages.order_transactions.reference")}</Th>
                <Th>{t("pages.order_transactions.branch")}</Th>
                <Th>{t("pages.order_transactions.orderRef")}</Th>
                <Th>{t("pages.order_transactions.type")}</Th>
                <Th>{t("pages.order_transactions.business_date")}</Th>
                <Th>{t("pages.order_transactions.created")}</Th>
            </Tr>
        </Thead>
        <Tbody>
            {
            returnedData?.map((item, index) => (
                <Tr key={index}>
                    <Td>{item.Ref}</Td>
                    <Td>{item.BranchName}</Td>
                    <Td> {item?.OrderRef}</Td>
                    <Td> {item.Type} </Td>
                    <Td> {item.UserDate} </Td>
                    <Td>{item?.Created}</Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
           currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
